import { render, staticRenderFns } from "./ScopeEdit.vue?vue&type=template&id=52b65838&"
import script from "./ScopeEdit.vue?vue&type=script&lang=js&"
export * from "./ScopeEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports